import React from "react";

const Heading = ({ children }) => {
  return (
    <h1 className="w-full text-center mb-6 text-2xl sm:text-3xl font-bold text-gray-800">
      {children}
    </h1>
  );
};


export default Heading;
